// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sizeChartTable":"D0HHq","hovered":"Ha-Mt","chartTable":"OxSiF"};